// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"1c8d27cf","243":"b733e031","374":"5b4533a4","681":"842c2d2b","848":"7c0ed7df","876":"20d047cb"}[chunkId] + ".chunk.css";
};